const DEFAULT_SAMPLE_RATE_HZ = 16_000;
export class PcmStreamPlayer {
    audioContext;
    audioSources = new Set();
    nextAudioTime = 0;
    constructor(sampleRateHz = DEFAULT_SAMPLE_RATE_HZ) {
        this.audioContext = new AudioContext({ sampleRate: sampleRateHz });
    }
    async resume() {
        if (this.audioContext.state !== 'running') {
            await this.audioContext.resume();
        }
    }
    playChunk(pcm) {
        const pcm16 = new Int16Array(pcm);
        const float32 = new Float32Array(pcm16.length);
        for (let i = 0; i < pcm16.length; i++) {
            float32[i] = pcm16[i] / 32768;
        }
        const buffer = this.audioContext.createBuffer(1, float32.length, this.audioContext.sampleRate);
        buffer.copyToChannel(float32, 0);
        const audioSource = this.audioContext.createBufferSource();
        audioSource.buffer = buffer;
        audioSource.connect(this.audioContext.destination);
        audioSource.onended = () => {
            this.audioSources.delete(audioSource);
        };
        this.audioSources.add(audioSource);
        if (this.nextAudioTime < this.audioContext.currentTime) {
            this.nextAudioTime = this.audioContext.currentTime;
        }
        audioSource.start(this.nextAudioTime);
        this.nextAudioTime += buffer.duration;
    }
    stop() {
        this.audioSources.forEach((source) => {
            try {
                source.stop();
            }
            catch {
                // Source may already be stopped.
            }
        });
        this.audioSources.clear();
        this.nextAudioTime = 0;
    }
    dispose() {
        this.stop();
        void this.audioContext.close();
    }
}
